<div class="app-container">
  <div style="margin:15px">
    <mat-card-header style="display:flex; padding: 0;">
      <img *ngIf='!isDarkMode()' mat-card-avatar src="/assets/images/third-party-openai-logo.svg" style="width:25px; height: 25px;">
      <img *ngIf='isDarkMode()' mat-card-avatar src="/assets/images/third-party-openai-logo-white.svg" style="width:25px; height: 25px;">
      <mat-card-title>OpenAI</mat-card-title>
      <div *ngIf="!isLoading && isLinked" style="font-size: 10px;" class="flex--column flex-align--flex-end">LINKED</div>
    </mat-card-header>
    <p style="font-size: 14px; margin: 14px 0;">
      OpenAI is an AI research and deployment company. Our mission is to ensure that artificial general intelligence benefits all of humanity.
    </p>
    <button *ngIf="isLoading" mat-stroked-button [disabled]="disabled" color="basic" style="width: 100%; pointer-events:none">
      <mat-icon><mat-spinner color="primary" diameter="20"></mat-spinner></mat-icon>
    </button>
    <button *ngIf="!isLoading && !isLinked" mat-flat-button color="primary" style="width:100%; cursor:pointer;" (click)="link()">Setup</button>
    <button *ngIf="!isLoading && isLinked" mat-stroked-button color="basic" style="width: 100%;" (click)="link()">Integration Settings</button>
  </div>
</div>